import { Navigate, NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, FileText, Upload, Tags, Store, Image, ArrowLeft, LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Mascot } from "../../components/Mascot";

const NAV = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Dashboard" },
  { to: "/admin/content", icon: FileText, label: "Content" },
  { to: "/admin/import", icon: Upload, label: "Import" },
  { to: "/admin/taxonomy", icon: Tags, label: "Taxonomy" },
  { to: "/admin/merchants", icon: Store, label: "Merchants" },
  { to: "/admin/media", icon: Image, label: "Media" },
];

export default function AdminLayout() {
  const { user, loading, logout, isStaff } = useAuth();
  if (loading) return <div className="flex min-h-screen items-center justify-center text-slate-400">Loading…</div>;
  if (!isStaff) return <Navigate to="/en/login" replace />;

  return (
    <div className="flex min-h-screen bg-slate-50">
      <aside className="fixed inset-y-0 left-0 hidden w-60 flex-col border-r border-slate-200 bg-white lg:flex">
        <div className="flex h-16 items-center gap-2 border-b border-slate-200 px-6">
          <Mascot className="h-7 w-7" /><span className="font-heading text-lg font-extrabold">LIVYVIO</span>
          <span className="ml-1 rounded bg-emerald-100 px-1.5 py-0.5 text-[10px] font-bold text-emerald-700">CMS</span>
        </div>
        <nav className="flex-1 space-y-1 p-4">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-emerald-600 text-white" : "text-slate-600 hover:bg-slate-100"}`}>
              <n.icon className="h-4 w-4" />{n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-slate-200 p-4">
          <Link to="/en" className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-slate-500 hover:bg-slate-100"><ArrowLeft className="h-4 w-4" />View site</Link>
          <button onClick={logout} className="mt-1 flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-red-600 hover:bg-red-50"><LogOut className="h-4 w-4" />Log out</button>
          <div className="mt-3 truncate px-3 text-xs text-slate-400">{user.email}</div>
        </div>
      </aside>
      <div className="flex-1 lg:pl-60">
        <div className="lg:hidden flex h-14 items-center gap-2 border-b bg-white px-4">
          <Mascot className="h-6 w-6" /><span className="font-heading font-bold">LIVYVIO CMS</span>
          <nav className="ml-auto flex gap-1">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `rounded-md p-2 ${isActive ? "bg-emerald-600 text-white" : "text-slate-500"}`}><n.icon className="h-4 w-4" /></NavLink>
            ))}
          </nav>
        </div>
        <main className="p-5 sm:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
